import { useQuery } from '@tanstack/react-query';
import { GetInternshipById, GetOrganizationById } from '../helper/apiHelper';
import type { PaperWorkLanguage } from '../Types/interfaces';

/** Paperwork language of the organization that hosts the given internship process. */
export const usePaperWorkLanguageOfProcess = (
  processId?: number | string
): PaperWorkLanguage | undefined => {
  const { data } = useQuery({
    queryKey: ['paperWorkLanguageOfProcess', processId],
    queryFn: async (): Promise<PaperWorkLanguage | undefined> => {
      const process = await GetInternshipById(Number(processId));
      if (!process) return undefined;
      const organization = await GetOrganizationById(
        String(process.organizationId)
      );
      return organization?.language;
    },
    enabled: processId !== undefined && processId !== null && processId !== '',
    staleTime: 5 * 60 * 1000,
  });

  return data;
};
